import { useState } from 'react';
import { Asset } from '@/api/generatedApi';
import { HeaderText } from '@/components/HeaderText';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Collapse, IconButton } from '@mui/material';
import { DependencyTreeContainer } from './DependencyTreeContainer';
import { DependencyContext } from './DependencyTreeView';
export interface DependencyTreeDetailsProperties {
  asset?: Asset;
  onTreeItemClick?: (itemId: string, context?: DependencyContext, selectionPath?: string[]) => void;
  selectedSelectionPath?: string[];
  readOnly?: boolean;
}

export const DependencyTreeDetails = ({
  asset,
  onTreeItemClick,
  selectedSelectionPath,
  readOnly,
}: DependencyTreeDetailsProperties) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return asset?.hasDependencies ? (
    <Box color='text.primary'>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <HeaderText margin={'4px 8px'}>Dependency Tree</HeaderText>
        <IconButton
          size='small'
          aria-label={isExpanded ? 'Collapse dependency tree' : 'Expand dependency tree'}
          aria-expanded={isExpanded}
          onClick={() => setIsExpanded(expanded => !expanded)}
        >
          {isExpanded ? <ExpandLess fontSize='small' /> : <ExpandMore fontSize='small' />}
        </IconButton>
      </Box>

      <Collapse in={isExpanded}>
        <DependencyTreeContainer
          asset={asset}
          onTreeItemClick={onTreeItemClick}
          selectedSelectionPath={selectedSelectionPath}
          readOnly={readOnly}
        />
      </Collapse>
    </Box>
  ) : undefined;
};
